export const API_URL = import.meta.env.VITE_API_URL;
export const APP_URL = import.meta.env.VITE_APP_URL;
export const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN;

// UAE Pass logout URL - redirects to our app root after logout
export const UAE_PASS_LOGOUT_URL = `https://stg-id.uaepass.ae/idshub/logout?redirect_uri=${APP_URL}`;
